import { DropDownItem } from "../dropdown/dropdown-item.model";

export class MultiDropDownItem extends DropDownItem {
  checked: boolean = false;
  groupValue?: string = "";
}
